import service from './request'

export default {
  cadastrarVoucher (voucher) {
    console.log(voucher)
    return service({
      url: '/administradorEmpresa/cadastrarVoucher',
      method: 'post',
      data: voucher
    })
  },
  listarVouchers (idEmpresa) {
    return service({
      url: `/administradorEmpresa/listarVouchers?id=${idEmpresa}`,
      method: 'get'
    })
  },
  vincularVoucher (usuario, voucher) {
    return service({
      url: '/administradorEmpresa/vincularVoucher',
      method: 'post',
      data: {
        usuario: usuario,
        voucher: voucher
      }
    })
  }

}
